module.exports = __webpack_public_path__ + "img/Full-Logo-Gold.144f1298.png";